import { render, staticRenderFns } from "./BookingCancellationCompleted.vue?vue&type=template&id=2cf880b0"
import script from "./BookingCancellationCompleted.vue?vue&type=script&lang=js"
export * from "./BookingCancellationCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports